
import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { auth } from "helper/Utility";
import { scheduleAutoLogout, clearAutoLogout } from "helper/tokenExpiry";

const ProtectedHrRoute = ({ children }) => {
    const navigate = useNavigate();
    const authData = auth("admin");

    // No token → login
    if (!authData?.token) {
        return <Navigate to="/admin/login" replace />;
    }

    // Must be hr role
    if (authData?.role !== "hr") {
        if (authData?.role === "admin") {
            return <Navigate to="/admin/dashboard" replace />;
        }
        return <Navigate to="/admin/login" replace />;
    }

    // 2FA must be verified
    if (!authData?.is2FAVerified) {
        return <Navigate to="/admin/login" replace />;
    }

    // Check if token already expired (handles page refresh after expiry)
    try {
        const payload = JSON.parse(atob(authData.token.split('.')[1]));
        if (payload.exp * 1000 < Date.now()) {
            sessionStorage.clear();
            return <Navigate to="/admin/login" replace />;
        }
    } catch (e) {
        sessionStorage.clear();
        return <Navigate to="/admin/login" replace />;
    }

    return (
        <HrTokenExpiryWatcher navigate={navigate}>
            {children}
        </HrTokenExpiryWatcher>
    );
};

const HrTokenExpiryWatcher = ({ children, navigate }) => {
    useEffect(() => {
        // Auto-logout when token expires (2h)
        scheduleAutoLogout(() => {
            sessionStorage.clear();
            navigate('/admin/login', { replace: true });
        });

        return () => clearAutoLogout();
    }, [navigate]);

    return children;
};

export default ProtectedHrRoute;
